export default {
    kn_dashboard_url: 'https://helpcenter.brainspro.com/',
    kn_create_user_url: 'https://helpcenter.brainspro.com/',
    kn_custom_domain_url: 'https://helpcenter.brainspro.com/',
    kn_branding_url: 'https://helpcenter.brainspro.com/',
    kn_legal_url: 'https://helpcenter.brainspro.com/',
    kn_video_url: 'https://helpcenter.brainspro.com/',
    kn_categories_url: 'https://helpcenter.brainspro.com/',
    kn_massive_import_url: 'https://helpcenter.brainspro.com/'
}